import { useEffect } from "react";

/** Sets document.title as "<title> · AquaTrack"; restores on unmount. */
export function usePageTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = `${title} · AquaTrack`;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
